import React from 'react';

import { IconProps } from './types';

const SandClockIcon: React.FC<IconProps> = props => {
  const { width = '42', height = '68', opacity = '1', fillColor = 'var(--red-base)' } = props;
  return (
    <svg width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity={opacity} fill={fillColor}>
        <path d="M51 62.333h-2.833v-9.916A21.28 21.28 0 0 0 37.513 34a21.221 21.221 0 0 0 10.654-18.417V5.667H51A2.834 2.834 0 0 0 51 0H2.833a2.833 2.833 0 0 0 0 5.667h2.834v9.916A21.222 21.222 0 0 0 16.32 34 21.279 21.279 0 0 0 5.667 52.417v9.916H2.833a2.833 2.833 0 1 0 0 5.667H51a2.833 2.833 0 0 0 0-5.667Zm-39.667-9.916a15.612 15.612 0 0 1 17.142-15.584A16.065 16.065 0 0 1 42.5 53.04v7.877a1.417 1.417 0 0 1-1.417 1.416H12.75a1.416 1.416 0 0 1-1.417-1.416v-8.5Zm1.417-46.75h28.333A1.417 1.417 0 0 1 42.5 7.083v7.82a16.009 16.009 0 0 1-14.025 16.264 15.584 15.584 0 0 1-17.142-15.584v-8.5a1.417 1.417 0 0 1 1.417-1.416Z" />
        <path d="M26.917 27.285a11.334 11.334 0 0 0 9.718-6.148 1.417 1.417 0 0 0-1.218-2.125h-17a1.418 1.418 0 0 0-1.218.821 1.416 1.416 0 0 0 0 1.417 11.333 11.333 0 0 0 9.718 6.035ZM29.042 44.172a2.835 2.835 0 0 0-4.25 0l-9.435 10.625a2.833 2.833 0 0 0 2.125 4.704h18.87a2.833 2.833 0 0 0 2.125-4.704l-9.435-10.625Z" />
      </g>
    </svg>
  );
};

export default SandClockIcon;
